import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Col, Row } from 'react-bootstrap';

// import Polar from '../../Charts/Phasor';
import PhasorDiagram from './PhasorDiagram';
import ChartLoader from '../../Loaders/ChartLoader';
import { act_GetPhasorChartsData } from '../../../actions/EEReportAction';
import Auth from '../../../shared/Auth';

const options = {
  r_current: { rI_Mag: 0, rI_Ph: 0 },
  y_current: { yI_Mag: 0, yI_Ph: 0 },
  b_current: { bI_Mag: 0, bI_Ph: 0 },
  r_voltage: { rV_Mag: 0, rV_Ph: 0 },
  y_voltage: { yV_Mag: 0, yV_Ph: 0 },
  b_voltage: { bV_Mag: 0, bV_Ph: 0 },
};

class PhasorDiagramChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options,
      reinitialize: true,
      noData: false,
      InstantaneousData: [],
      newPhasorDiagramData: {},
    };
    this.toTimestamp = this.toTimestamp.bind(this);
    this.getPhasorDiagramData = this.getPhasorDiagramData.bind(this);
    this.prepareChartData = this.prepareChartData.bind(this);
  }

  toTimestamp(strDate) {
    const datum = Date.parse(strDate);
    return datum;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.deviceId !== nextProps.deviceId) {
      this.setState({ reinitialize: true, noData: false });
      this.bindData(nextProps.deviceId);
    }
  }

  UNSAFE_componentWillMount() {
    this.bindData(this.props.deviceId);
  }

  async bindData(deviceID) {
    const checkToken = await Auth();
    if (checkToken) {
      this.getPhasorDiagramData(deviceID);
    }
  }

  getPhasorDiagramData(deviceID) {
    const current = this;
    this.props
      .act_GetPhasorChartsData(deviceID)
      .then((res) => {
        if (res.payload.data.statusCode === 200) {
          current.prepareChartData(res.payload.data.result);
        } else {
          current.prepareChartData([]);
        }
      })
      .catch(() => {
        current.prepareChartData([]);
      });
  }

  prepareChartData(data) {
    if (data.length > 0) {
      let r_current = {};
      let y_current = {};
      let b_current = {};
      let r_voltage = {};
      let y_voltage = {};
      let b_voltage = {};

      for (const i in data) {
        r_current = { rI_Ph: data[i].iaph, rI_Mag: data[i].iarms };
        y_current = { yI_Ph: data[i].ibph, yI_Mag: data[i].ibrms };
        b_current = { bI_Ph: data[i].icph, bI_Mag: data[i].icrms };
        r_voltage = { rV_Ph: data[i].vaph, rV_Mag: data[i].varms };
        y_voltage = { yV_Ph: data[i].vbph, yV_Mag: data[i].vbrms };
        b_voltage = { bV_Ph: data[i].vcph, bV_Mag: data[i].vcrms };
      }
      this.setState({
        options: {
          r_current,
          y_current,
          b_current,
          r_voltage,
          y_voltage,
          b_voltage,
        },
        reinitialize: false,
      });
    } else {
      this.setState({ reinitialize: false, noData: true });
    }
  }

  render() {
    const { reinitialize, noData } = this.state;
    if (reinitialize) return <ChartLoader height="150" width="600" />;
    if (noData) return 'No data available';
    return (
      <Row>
        <Col lg={12}>
          {/* <Polar style={{ height: "180px" }} options={this.state.options} /> */}
          <center>
            <PhasorDiagram phasorData={this.state.options}></PhasorDiagram>
          </center>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      act_GetPhasorChartsData,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PhasorDiagramChart);
